/**
 * HTML5 drag-and-drop reorder for a list.
 */
export function bindSortableList(listEl, options) {
  if (!listEl || listEl.dataset.sortableBound) return;
  listEl.dataset.sortableBound = '1';

  const itemSelector = options.itemSelector ?? '[data-sortable-id]';
  const handleSelector = options.handleSelector ?? '[data-sortable-handle]';

  let draggedEl = null;

  function items() {
    return [...listEl.querySelectorAll(itemSelector)];
  }

  function orderedIds() {
    return items().map((el) => el.dataset.sortableId).filter(Boolean);
  }

  function bindItem(item) {
    item.setAttribute('draggable', 'true');

    const handle = item.querySelector(handleSelector);
    if (handle) {
      handle.addEventListener('mousedown', () => {
        item.dataset.dragEnabled = '1';
      });
    }

    item.addEventListener('dragstart', (e) => {
      if (handle && !item.dataset.dragEnabled) {
        e.preventDefault();
        return;
      }
      draggedEl = item;
      item.classList.add('sortable-item--dragging');
      e.dataTransfer.effectAllowed = 'move';
      e.dataTransfer.setData('text/plain', item.dataset.sortableId ?? '');
    });

    item.addEventListener('dragend', () => {
      item.classList.remove('sortable-item--dragging');
      delete item.dataset.dragEnabled;
      draggedEl = null;
      items().forEach((el) => el.classList.remove('sortable-item--over'));
    });

    item.addEventListener('dragover', (e) => {
      e.preventDefault();
      if (!draggedEl || draggedEl === item) return;
      e.dataTransfer.dropEffect = 'move';
      item.classList.add('sortable-item--over');
    });

    item.addEventListener('dragleave', () => {
      item.classList.remove('sortable-item--over');
    });

    item.addEventListener('drop', async (e) => {
      e.preventDefault();
      item.classList.remove('sortable-item--over');
      if (!draggedEl || draggedEl === item) return;

      const all = items();
      const from = all.indexOf(draggedEl);
      const to = all.indexOf(item);
      if (from < 0 || to < 0) return;

      if (from < to) {
        item.after(draggedEl);
      } else {
        item.before(draggedEl);
      }

      try {
        await options.onReorder(orderedIds());
      } catch (err) {
        alert(err.message);
      }
    });
  }

  items().forEach(bindItem);
}
